<div>

  <div *ngIf="firstLevel" class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">
        <span>Monitoring Report of Device Close Status</span>
        <!--<span style="margin-left: 30px; font-weight: 500; font-size: 10px;" class="text-muted">20/06/2018 - 17-07-2018</span>-->
      </h5>

      <div class="heading-elements">
        <ul class="icons-list">
          <!--<li><i class="icon-file-pdf"></i></li>-->
          <!--<li><i class="icon-file-excel"></i></li>-->
          <!--<li><a data-action="close"></a></li>-->
        </ul>
      </div>

    </div>
    <div class="table-responsive">
      <table *ngIf="!regionLoader" class="table datatable-show-all">
        <thead>
        <tr>
          <th *ngIf="state == 'Delhi'">S. No.</th>
          <th>Region Name</th>
          <th>Name of Officer</th>
          <th>District</th>
          <th style="text-align: center;">Total No of Unit Stations</th>
          <th style="text-align: center;">No of Unit Stations Offline</th>
        </tr>
        </thead>

        <tbody *ngFor="let regionDetail of firstLevel | keyvalue let i = index" [attr.data-index]="i">
        <tr *ngFor="let region of regionDetail.value | keyvalue">
          <!--<tr>-->
          <th *ngIf="state == 'Delhi'">{{i+1}}</th>
          <td>{{region.key}}</td>
          <td>{{region.value.name}}</td>
          <td>{{region.value.city}}</td>
          <td style="text-align: center;">{{region.value.industry_count}}</td>
          <td style="text-align: center;">
            <a *ngIf="region.value.total_close" (click)="getCloseIndustryList(region.key,region.value.name)" data-toggle="modal" data-target="#secondLevel">{{region.value.total_close}}</a>
            <a style="color: black; cursor: not-allowed;" *ngIf="!region.value.total_close">{{region.value.total_close}}</a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="regionLoader">
      <div colspan="12" class="col-lg-12 text-center" style="height: 180px;">
        <div style="margin-top: 50px;">
          <img src="/assets/images/load.gif" />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!firstLevel"  class="col-lg-12 text-center" style="height: 180px;">
    <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 50px;">
      No Close Unit Station Report Found
    </div>
  </div>

  <div id="secondLevel" class="modal fade" role="dialog">
    <div class="modal-dialog">

      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title" *ngIf="!moreDetailDrilled">{{selectedOfficerName}} | {{selectedRegionName}}</h4>
          <h4 class="modal-title" *ngIf="moreDetailDrilled">{{selectedIndustryName}} | {{selectedIndustryAddress}}</h4>
        </div>
        <div class="modal-body">
          <div *ngIf="!moreDetailDrilled" class="table-responsive">
            <table class="table datatable-show-all">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S. No.</th>
                <th>Name of Unit Station</th>
                <th>Address of Unit Station</th>
                <th>District</th>
                <th>Average Close Time</th>
                <th>No of Interval of Close/Non-Operation CEMS</th>
                <th>Name of Parameter Displayed by Industry</th>
                <th>Detail Status</th>
              </tr>
              </thead>

              <tbody *ngIf="!industryLoader">
              <tr *ngFor="let industry of closeIndustryList | keyvalue let i = index" [attr.data-index]="i">
                <th *ngIf="state == 'Delhi'">{{i+1}}</th>
                <td>{{industry.value.name}}</td>
                <td>{{industry.value.address}}</td>
                <td>{{industry.value.city}}</td>
                <td><span class="label label-danger">{{industry.value.average_time}} Hours</span></td>
                <td><span class="label label-danger">{{industry.value.total_interval}} Times</span></td>
                <td>
                  {{industryParameterList[industry.key]['parameter']}}
                </td>
                <td>
                  <button (click)="getIndustryCloseTimeWise(industry.value.name,industry.value.address,industry.value.id)" class="btn btn-xs btn-primary"><i class="icon icon-more2"></i> </button>
                </td>
              </tr>
              </tbody>

              <tbody *ngIf="industryLoader" >
              <tr>
                <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                  <div style="margin-top: 50px;">
                    <img src="/assets/images/load.gif" />
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="moreDetailDrilled">
            <button (click)="backToPreviousLevel()" class="btn btn-xs btn-primary"><strong><i class="icon icon-arrow-left5"></i>Back</strong> </button>
            <div class="table-responsive">
              <table class="table datatable-show-all">
                <thead>
                <tr>
                  <th style="text-align: center;">SNo.</th>
                  <th style="text-align: center;">Close From</th>
                  <th style="text-align: center;">Close Till</th>
                </tr>
                </thead>
                <tbody *ngIf="!historyLoader">
                <tr *ngFor="let history of closeIndustryHistory | keyvalue let i = index" [attr.data-index]="i">
                  <td style="text-align: center;">{{i + 1}}</td>
                  <td style="text-align: center;">
                    <span class="label label-danger">{{history.value.from_date_time | date: 'dd/MM/yyyy HH:mm'}}</span>
                  </td>
                  <td style="text-align: center;">
                    <span class="label label-danger" *ngIf="history.value.to_date_time"> {{history.value.to_date_time | date: 'dd/MM/yyyy HH:mm'}}</span>
                    <span class="label label-danger" *ngIf="!history.value.to_date_time"> Till Now</span>
                  </td>
                </tr>
                </tbody>
                <tbody *ngIf="historyLoader" >
                <tr>
                  <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                    <div style="margin-top: 50px;">
                      <img src="/assets/images/load.gif" />
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>